import $http from "../../axios";
import * as mutations from './mutations'
import {Notification} from "element-ui";

export async function downloadProductsTemplate({state}) {
    let name = 'productos.xlsx';
    state.loading.message_loading = 'Descargando Plantilla De Incorporación De Productos';
    state.loading.module = true;

    try {
        const response = await $http({
            url: '/api/descargar-plantilla-productos',
            method: 'GET',
            responseType: 'blob',
        });

        state.loading.module = false;

        // Crea un enlace para descargar el archivo
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', name);
        document.body.appendChild(link);
        link.click();

        // Elimina el enlace después de la descarga
        link.remove();
    } catch (error) {
        state.loading.module = false;
        Notification.error({
            title: 'Error!',
            message: error.message,
            type: 'error',
            duration: 3000,
            customClass: 'notification-box',
        });
    }
}
export async function uploadProductsTemplate({state}) {
    let formData = new FormData();
    formData.append('file', state.file);
    state.loading.message_loading = 'Cargando Plantilla De Incorporación De Productos' ;
    state.loading.module = true ;
    $http.post(`/api/cargar-plantilla-productos`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    ).then(function(){
        state.loading.module = false ;
        Notification.success({
            title: "Success!",
            message: 'Archivo cargado',
            type: "success",
            duration: 3000,
            customClass: "notification-box"
        });
    })
        .catch(error => {
            state.loading.module = false ;
            Notification.error({
                title: "Error!",
                message: error.message +' Verifique el archivo sea un csv delimitado por punto y coma (;) y que corresponda a la información de la plantilla',
                type: "error",
                duration: 3000,
                customClass: "notification-box"
            });
        });
}



// WEBPACK FOOTER //
// ./src/modules/import-products/actions.js